import type { ReactNode } from "react";
import Navbar from "./Navbar";
import TopBar from "./TopBar";
import Footer from "./Footer";

interface SiteLayoutProps {
  children: ReactNode;
  navVariant?: "overlay" | "solid";
}

export default function SiteLayout({ children, navVariant = "overlay" }: SiteLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50 text-foreground-950">
      <TopBar />
      <Navbar variant={navVariant} />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}